/**
 * Ministry options for medical professionals
 */
export enum Ministry {
  HEALTH = "health",
  EDUCATION = "education",
  HIGHER_EDUCATION = "higher_education",
  DEFENSE = "defense",
  INTERIOR = "interior",
  FINANCE = "finance",
  FOREIGN_AFFAIRS = "foreign_affairs",
  JUSTICE = "justice",
  OIL = "oil",
  ELECTRICITY = "electricity",
  WATER_RESOURCES = "water_resources",
  AGRICULTURE = "agriculture",
  TRADE = "trade",
  INDUSTRY = "industry",
  TRANSPORTATION = "transportation",
  COMMUNICATIONS = "communications",
  LABOR_SOCIAL_AFFAIRS = "labor_social_affairs",
  MIGRATION_DISPLACEMENT = "migration_displacement",
  YOUTH_SPORTS = "youth_sports",
  CULTURE = "culture",
  TOURISM_ANTIQUITIES = "tourism_antiquities",
  HOUSING_CONSTRUCTION = "housing_construction",
  PLANNING = "planning",
  ENVIRONMENT = "environment",
  SCIENCE_TECHNOLOGY = "science_technology",
  MUNICIPALITIES = "municipalities"
}

/**
 * Array of all ministry values for easy iteration
 */
export const MINISTRY_VALUES = Object.values(Ministry);

/**
 * Human-readable labels for ministry options
 */
export const MINISTRY_LABELS: Record<Ministry, string> = {
  [Ministry.HEALTH]: "Health",
  [Ministry.EDUCATION]: "Education",
  [Ministry.HIGHER_EDUCATION]: "Higher Education",
  [Ministry.DEFENSE]: "Defense",
  [Ministry.INTERIOR]: "Interior",
  [Ministry.FINANCE]: "Finance",
  [Ministry.FOREIGN_AFFAIRS]: "Foreign Affairs",
  [Ministry.JUSTICE]: "Justice",
  [Ministry.OIL]: "Oil",
  [Ministry.ELECTRICITY]: "Electricity",
  [Ministry.WATER_RESOURCES]: "Water Resources",
  [Ministry.AGRICULTURE]: "Agriculture",
  [Ministry.TRADE]: "Trade",
  [Ministry.INDUSTRY]: "Industry",
  [Ministry.TRANSPORTATION]: "Transportation",
  [Ministry.COMMUNICATIONS]: "Communications",
  [Ministry.LABOR_SOCIAL_AFFAIRS]: "Labor & Social Affairs",
  [Ministry.MIGRATION_DISPLACEMENT]: "Migration & Displacement",
  [Ministry.YOUTH_SPORTS]: "Youth & Sports",
  [Ministry.CULTURE]: "Culture",
  [Ministry.TOURISM_ANTIQUITIES]: "Tourism & Antiquities",
  [Ministry.HOUSING_CONSTRUCTION]: "Housing & Construction",
  [Ministry.PLANNING]: "Planning",
  [Ministry.ENVIRONMENT]: "Environment",
  [Ministry.SCIENCE_TECHNOLOGY]: "Science & Technology",
  [Ministry.MUNICIPALITIES]: "Municipalities"
};